import { React, useState} from "react";
import axios from "axios";
import PhoneIcon from '@mui/icons-material/Phone';
import bnrimg  from "../../src/images/homebnr.png";
import shp1  from "../../src/images/dotsg.png";
import shp2  from "../../src/images/dotsr.png";
import { enquirysubmit } from "../Api_list";
let color = {};
const Home_enq = () => {
     
      const [name, setName] = useState("");
      const [isChecked, setIsChecked] = useState(false);
      const [mobileNumber, setMobileNumber] = useState("");
      const [message, setMessage] = useState("");
      const handleOnChange = () => {
        setIsChecked(!isChecked);
      };
      let handleSubmit = async (e) => {
        e.preventDefault();
        let ch = "";
        if( isChecked  === true){
          ch = 'Internship';
        }
        if( isChecked  === false){
          ch = 'job';
        }
        const post = {
          full_name: name,
          email_id: '',
          looking_for: ch,
          type : 'career_planing',
          mobile_no: mobileNumber,
        } 
      if((name.length != 0) && (mobileNumber.length === 10)){
        try { 
          var headerData = {"headers":{
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": window.HEADERSAUTH, 
          }} 
          const res = await axios.post(enquirysubmit, post, headerData)
          if (res.status === 200) {
            color.color = 'green';
            setName("");setMobileNumber("");
                setMessage('Thank you, your call back request has been submitted successfully!');
                setTimeout(() => {
                  setMessage('');
                }, 5000);
              } else {
                color.color = 'red';
                setMessage("Some error occured");
                setTimeout(() => {
                  setMessage('');
                }, 5000);
              }
        } catch (e) {
          color.color = 'red';
          setMessage("Some error occured");
          setTimeout(() => {
            setMessage('');
          }, 5000);
        }
      }else{
        color.color = 'red';
        setMessage("Please enter valid mobile number"); 
        setTimeout(() => {
          setMessage('');
        }, 5000);
      }
      };
 
    return (
        <>
    <section className="homebanner">
        <div className="container">
          <div className="row j-align-center top_form_row">
            <div className="col-sm-6">
              <div className="bnrtext_form">
                <h1>
                  <span>Start</span> With India’s Most Trusted{" "}
                  <span>Best Career</span> Planning Platform
                </h1>
                <p>
                Unlock Your Potential, Embrace Your Future!
                  <div className="message">{message ? <p style={color}>{message}</p> : null}</div> 
                </p>
                <div className="row">
              
                <form onSubmit={handleSubmit}>
                    <div className="col-md-12 col-12 col-lg-12 form-element">
                      <label>Name</label>
                      <input type="text" onChange={(e) => setName(e.target.value)} value={name} className="form-control"  placeholder="Enter Your Full Name"/>
                    </div>
                    <div className="col-md-12 col-12 col-lg-12 form-element">
                      <label>Contact Number</label>
                      <input type="text" onChange={(e) => setMobileNumber(e.target.value)} value={mobileNumber} className="form-control" maxLength={10}  placeholder="Enter Your Contact Number"/>
                    </div>
                    <div className="row flex-reverse">
                        <div className="col-md-8 col-12 col-lg-8 form-element">
                            <div class="form-check form-switch">
                                <input class="form-check-input" onChange={handleOnChange} checked={isChecked}  type="checkbox" role="switch" id="flexSwitchCheckChecked"/>
                                <label class="form-check-label" for="flexSwitchCheckChecked">Looking for Internship </label>
                            </div>
                        </div>
                        <div className="col-md-4 col-12 col-lg-4 form-element">
                           <button  type="submit" className="callme sitebtn"> <PhoneIcon/> Call Me Back</button>
                        </div>
                    </div>
                    <div className="col-md-12 col-12 col-lg-12">
                        <p>By submitting this form, you accept and agree to our <a href="/terms-and-conditions">Terms of Use</a></p>
                    </div>
                  </form> 
                </div>
              </div>
            </div>
            <div className="col-sm-6">
               <div className="bnr_shpwrpr">
                 <img src={shp1} className="shp1 movingup " />
                 <img src={bnrimg} className="bnrimg" alt="image" />
                 <img src={shp2} className="shp2 moving" />
               </div>
            </div>
          </div>
        </div>


        {/* <div>
        <button onClick={() => sayHello('James')}>Greet</button>
      <h2>Count: {count}</h2>
      <button onClick={handleClick}>Increment</button>
    </div> */}
      </section>
        </>
    )
}
export default Home_enq;
